import { ITriggerRequest } from "../interfaces/ITrigger";
import api from "../services/trigger/api";

class TriggerAPI {
    trigger = async (request: ITriggerRequest) => await api.get(`/acionamento/chaveVirtual/${request.acionamentoId}/${request.visitanteId}/${request.latitude}/${request.longitude}/${request.visitanteId}/2`);
}

export default new TriggerAPI();